import { useClientContext } from "../../../hooks/ClientContext"
import { useLazyGetMasterAccountProjectsSummaryQuery } from "../../../services/clientprojectsummary/projectSummaryEndpoints";
import React from "react";

export const useGetProjectsSummary = () => {
    const { id: masterAccountId } = useClientContext();
    const [load, { data, error, isLoading, isFetching }] = useLazyGetMasterAccountProjectsSummaryQuery();
    const [cacheKey, setCacheKey] = React.useState(new Date().valueOf());
    const { pagination, results, totalProjectValue } = data || { pagination: { page: 1, pageSize: 5, totalCount: 0, totalPages: 1 }, results: [], totalProjectValue: 0 };
    const { page, totalCount, totalPages } = pagination;
    const hasMore = totalCount > 0 && page < totalPages;
    const isNextPageLoading = isFetching === true || isLoading === true;

    const loadMore = () => {
        // safety check to make sure we don't reload when already loading!
        if (isNextPageLoading) {
            return;
        }

        load({
            cacheKey,
            masterAccountId,
            page: page + 1,
            limit: 5,
        }).unwrap();
    };

    React.useEffect(() => {
        const newCacheKey = new Date().valueOf();
        load({ masterAccountId, cacheKey: newCacheKey, page: 1, limit: 5 }).unwrap().finally(() => {
            setCacheKey(() => newCacheKey)
        })
    }, [masterAccountId])

    return {
        data:results, error, isLoading, hasMore, loadMore, totalProjectValue, totalCount
    }
}